import type { SectionEnum, ContractStatusEnum } from 'gql/graphql';
import { ProjectContractTypeEnum } from 'gql/graphql';

export enum CalculatingTypeEnum {
    PERCENT = 'PERCENT',
    CALCULATION = 'CALCULATION',
}

export type ContractStatusData = {
    followers: ContractStatusEnum[];
    status: ContractStatusEnum;
};

export interface ConstructionType {
    id: number;
    code: string;
    name: string;
    description: string;
    shortName: string;
}

export interface Season {
    id: number;
    year: number;
}

export interface CalculatingType {
    constructionType: ConstructionType;
    season: Season;
    cost: number;
}

export interface OtherCost {
    id: string;
    name: string;
    section: SectionEnum;
    calculatingType: CalculatingTypeEnum;
    calculatingTypeValue?: number;
    limits: CalculatingType[];
}

export interface IListItem<T = any> {
    id: T;
    label: string;
    parentId?: T;
    workOrderObjectId?: T;
    workOrderChangeObjectId?: T;
}

export interface IListItemVersion<T = any> {
    id: T;
    label: string;
    parentId?: T;
    workOrderVersionId?: T;
}

export const contractTypeLabels: Record<ProjectContractTypeEnum, string> = {
    [ProjectContractTypeEnum.Frame]: 'Рамочный',
    [ProjectContractTypeEnum.Normal]: 'Обычный',
};

export const getContractTypeLabel = (contractTypeId: ProjectContractTypeEnum) => contractTypeLabels[contractTypeId];
